document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.load-more-fragances').forEach(button => {
    button.addEventListener('click', function() {
      const card = this.closest('.card-wrapper');
      const extraBullets = card.querySelectorAll('.extra-bullet');
      
      extraBullets.forEach(bullet => {
        bullet.style.display = 'flex';
      });
      
      this.style.display = 'none';
    });
  });
});
